
import { mapState, mapActions } from 'vuex'
import jwt from 'jsonwebtoken'

export default {
  data() {
    return {
      found: false,
      code: '',
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      active: false,
      checkedAccount: false,
      newUser: false,
      timeout: null,
      terms: false,
      optin: false,
      optin_sms: false,
      errors: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        code: ''
      },
      method: 'sms'
    }
  },
  computed: {
    ...mapState(['user', 'handoff', 'createAccount', 'channel', 'order']),
  },
  mounted() {
    if (!this.user) {
      if (this.handoff.email) {
        this.email = this.handoff.email
        this.next()
      }
      this.first_name = this.handoff.first_name
      this.last_name = this.handoff.last_name
      this.phone = this.handoff.phone
    }
  },

  watch: {
    '$route.path'(newPath) {
      if (newPath === '/order/confirm') {
        this.clearCustomerData()
      }
    }
  },

  methods: {
    ...mapActions([
      'accountLogout' // also supports payload `this.nameOfAction(amount)`
    ]),
    logout() {
      if(this.order && this.order.products.length) {
        console.log("ABANDON")
        if (this.channel == 'catering') {
          this.$braze.logCustomEvent('Abandon_Cart_Catering', {'Cart_Items': this.order.products, 'Cart_Cost': this.order.totals.total})
        } else {
          this.$braze.logCustomEvent('Abandon_Cart', {'Cart_Items': this.order.products, 'Cart_Cost': this.order.totals.total})
        }
      }
      this.accountLogout()
      const handoff = JSON.parse(JSON.stringify(this.handoff))
      handoff['email'] = ''
      this.$store.commit('setHandoff', handoff)
      this.$router.push('/')
    },
    checkEmail() {
      if ((/\S+@\S+\.\S+/.test(this.email))) { // valid email
        this.active = true
        const handoff = JSON.parse(JSON.stringify(this.handoff))
        handoff['email'] = this.email
        this.$store.commit('setHandoff', handoff)
      } else {
        this.active = false
      }
    },
    async checkCode() {
      console.log('check Code')
      if (this.code.length == 6) {
        this.active = true
      } else {
        this.active = false
      }
    },
    async checkAccount() {
      this.$store.commit('setLoading', true)
      const response = await this.$axios({
        method: 'post',
        url: '/api/v2/members/auth',
        headers: {
          verify: this.email,
          client_sub: window.location.href.includes('catering') || window.location.href.includes('2001') ? 'catering' : null
        },
        data: {
          provider: 'oloauth',
          email: this.email,
          method: this.method
        }
      }).then(res => {
        this.found = true
        this.checkedAccount = true; 

        if (this.found && this.checkedAccount) {
          this.active = false;
        }
      }).catch(err => {
        console.log(err.response)
        if (err.response.status == 404) {
          this.found = false
        }
        if (err.response.status == 429) {
          this.errors.email = 'Too many requests.'
        } else {
          this.errors.email = err.response.title
        }
      })
      this.$store.commit('setLoading', false)
    },
    sendByPhone() {
      this.method = 'sms'
      this.checkAccount()
    },
    sendByEmail() {
      this.method = 'email'
      this.checkAccount()
    },
    async loginAccount() {
      this.active = false;
      this.$store.commit('setLoading', true)
      let redirectUri;

      if (window.location.href.includes('catering') || window.location.href.includes('2001')) {
      redirectUri = 'https://catering.bojangles.com/account/oauthcallback';
      } else {
        redirectUri = process.env.OLO_REDIRECT_URI;
      }
      // if (this.channel === 'catering') {
      //   redirectUri = 'https://catering.bojangles.com/account/oauthcallback';
      // } else {
      //   redirectUri = process.env.OLO_REDIRECT_URI;
      // }

      console.log(process.env.GW_ENV, 'process.env.GW_ENV CustomerDetails')
      console.log(redirectUri, 'redirectUri CustomerDetails')

      const tokenV2 = await this.$axios({
        method: 'post',
        url: '/api/v2/members/auth',
        headers: {
          verify: this.code,
          client_sub: window.location.href.includes('catering') || window.location.href.includes('2001') ? 'catering' : null
        },
        data: {
          provider: 'oloauth',
          email: this.email,
          passwordless_code: this.code,
          redirect_uri: redirectUri,
          method: this.method
        }
      }).then(res => {
        return res.data.value
      }).catch(err => {
        if (err.response.status == 400) {
          setTimeout(() => {
            this.errors.code = 'Invalid code.'
          }, 1000)
        }
        this.active = true;
        return null
      })
      if (tokenV2) {
        const tokenV1 = await this.$axios({
          method: 'post',
          url: '/api/v1/members/sso',
          headers: {
          client_sub: window.location.href.includes('catering') || window.location.href.includes('2001') ? 'catering' : null
        },
          data: {
            provider: 'oloauth',
            token: tokenV2
          }
        }).then(res => {
          return res.data.tokens
        }).catch(err => {
          return null
        })
        if (tokenV1) {
          this.$store.commit('setToken', tokenV1)
          const user = await this.$api.getUser()
          if (user) {
            //Check for the current Signup in Braze before creating a new account
            const alias = await this.$api.exportUserProfileById({
              "email_address": user.email,
              "fields_to_export": ["user_aliases", "email", "external_id", "custom_attributes"]
            })

            if (!alias?.data?.users?.length) {
              let registrationCompletedEvent = this.channel !== 'catering' ? 'Registration_Completed' : 'Registration_Complete_Catering';
              // If no account was returned with the email address then no account exists and the user just created a new account
              // Log values to Braze from user profile
              this.$braze.changeUser(user.id) //user exists - time to login the user with Braze
              this.$braze.openSession()
              this.$braze.getUser().setEmail(user.email)
              this.$braze.getUser().setFirstName(user.first_name)
              this.$braze.getUser().setLastName(user.last_name)
              this.$braze.getUser().setPhoneNumber(user.phone.length == 10 ? '+1' + user.phone : user.phone)
              this.$braze.logCustomEvent(registrationCompletedEvent, { 'User': user })
              //Set either Catering or Ordering External ID to identify the user later
              if (this.channel === 'catering') {
                this.$braze.getUser().setCustomUserAttribute('catering_external_id', user.id)
              }
              else {
                this.$braze.getUser().setCustomUserAttribute('default_external_id', user.id)
              }
            }
            else {
              //Account returned - check for existing alias without external ID
              if (alias.data.message && alias.data.message == "success") {
                const user_alias = alias.data.users.find(user => {
                  return user.user_aliases.find(_alias => {
                    return _alias.alias_label == 'wisely' && !user.external_id
                  })
                })
                // Alias without External ID and Wisely Alias was found
                if (user_alias && user_alias.user_aliases?.length) {
                  const identify = await this.$api.usersIdentify({
                    "aliases_to_identify": [
                      {
                        "external_id": user.id,
                        "user_alias": user_alias.user_alias.user_aliases[0]
                      }
                    ],
                    "merge_behavior": "merge"
                  })
                }
                //Account returned from matching email address check which ID to use to login the user
                let external_id = alias.data.users[0].external_id
                this.$braze.changeUser(external_id)
                this.$braze.openSession()
              }
            }
            // Add Sparkfly Enrollment ID from Loyalty data
            const loyalty = await this.$api.getLoyalty()
            if (loyalty) {
              if (!alias?.data?.users?.length ||
                !alias.data.users[0]?.custom_attributes?.Sparkfly_Enrollment_ID ||
                alias.data.users[0]?.custom_attributes?.Sparkfly_Enrollment_ID != loyalty.id) {
                this.$braze.getUser().setCustomUserAttribute('Sparkfly_Enrollment_ID', loyalty.id)
              }

            }
            // Decode tokenV2 to get sparkfly member ID
            let sp_values = jwt.decode(tokenV2)
            if (!alias?.data?.users?.length ||
              !alias.data.users[0]?.custom_attributes?.Sparkfly_Member_ID ||
              alias.data.users[0]?.custom_attributes?.Sparkfly_Member_ID != sp_values?.f) {
              this.$braze.getUser().setCustomUserAttribute('Sparkfly_Member_ID', parseInt(sp_values?.f))
            }
          }
        }
      }
      this.$store.commit('setLoading', false)
    },
    async next() {
      if (!this.user && !this.newUser) {
        if (!this.checkedAccount) {
          await this.checkAccount()
        } else {
          await this.loginAccount()
        }
        if (!this.found && !this.errors.email) {
          this.newUser = true
        }
      }

      if (this.newUser) {
        this.$store.commit('setGuestUser', { 'email': this.email, 'phone': this.phone, 'firstName': this.first_name, 'lastName': this.last_name, 'optin': this.optin, 'optin_sms': this.optin_sms })
      }

    },
    updateDetails(field) {
      if (field == 'first_name') {
        this.errors.first_name = ''
      }
      if (field == 'last_name') {
        this.errors.last_name = ''
      }
      if (field == 'email') {
        this.errors.email = ''
      }
      if (field == 'phone') {
        this.errors.phone = ''
      }
      if (field == 'first_name' && !this.first_name) {
        this.errors.first_name = 'First name is required'
        return false
      }
      if (field == 'last_name' && !this.last_name) {
        this.errors.last_name = 'Last name is required'
        return false
      }
      if (field == 'email' && !(/\S+@\S+\.\S+/.test(this.email))) {
        this.errors.email = 'Invalid email address'
        return false
      }
      if (field == 'phone' && this.phone && this.phone.replace(/^\+?1/, '').length != 12) {
        this.errors.phone = 'Invalid phone number'
        return false
      }
      const handoff = JSON.parse(JSON.stringify(this.handoff))
      if (field == 'first_name') {
        handoff['first_name'] = this.first_name
      }
      if (field == 'last_name') {
        handoff['last_name'] = this.last_name
      }
      if (field == 'email') {
        handoff['email'] = this.email
      }
      if (field == 'phone') {
        handoff['phone'] = this.phone
      }
      this.$store.commit('setHandoff', handoff)
    },

    clearCustomerData() {
      this.first_name = ''
      this.last_name = ''
      this.email = ''
      this.phone = ''

      console.log('Cleared user infos')
    }
  },
}
